(function(){
    angular.module('tmx-app').directive("tmxGooglemaps",  tmxGoogleMaps);
    var byUs=false;
    function tmxGoogleMaps() {
        return {
            scope:{
                value:'=',
                name: '@',
                editable: '=',
                model:'='
            },
            restrict: 'E',
            templateUrl: 'common/directives/googlemaps/googlemaps.html',
            controller: ["$scope","NgMap","tmxUtility",tmxgoogleMapsCtrl],
            controllerAs:'tmxGoogleMapsCtrl'
        };
    }

    function tmxgoogleMapsCtrl($scope,ngMap,tmxUtility){
        var googleMaps=this;
        googleMaps.polygonArray = [];
        googleMaps.scope=$scope;
        googleMaps.scope.editable=false;
        googleMaps.scope.model=$scope.model
        var exists;
        exists = tmxUtility.exists;


        googleMaps.setPolygonColor = function(){
            if(exists(googleMaps.scope.model)) {	
                if(googleMaps.scope.model.flag==1){
                    googleMaps.scope.model.flag=0;


                    for(var j=0; j<googleMaps.polygonArray.length; j++) {

                        googleMaps.polygonArray[j].setMap(null);
                    }

                    if(exists(googleMaps.selectedShape)){
                        googleMaps.selectedShape.setMap(null);
                    }

                    if(exists(googleMaps.bermudaTriangle)) {
                        googleMaps.bermudaTriangle.setMap(null);
                    }

                    if(exists(googleMaps.selectedTriangle)) {
                        googleMaps.selectedTriangle.setMap(null);
                    }


                    googleMaps.bermudaTriangle=null;	
                    googleMaps.polygonArray = [];
                    googleMaps.polygonCoordsArray=[];	
                    googleMaps.polygonCoords = [];

                    LoadMap();
                    setMapValue();

                    googleMaps.polygonCoordss=[];
                    if(exists(googleMaps.scope.model.model) && !angular.isArray(googleMaps.scope.model.model)) {

                        var duplicate = angular.copy(googleMaps.scope.model.model);
                        duplicate = duplicate.replace("POLYGON ((", "");
                        var arr = duplicate.split(")");
                        var point = arr[0].split(", ");
                        for (var i = 0; i<point.length; i++) {
                            var coord = point[i].split(" ");
                            var point_lat = Number(coord[0]);
                            var point_lng = Number(coord[1]);
                            var obj = {lat:point_lat,lng:point_lng};
                            googleMaps.polygonCoords.push(obj);
                        }
                        googleMaps.selectedTriangle = new google.maps.Polygon({
                            paths: googleMaps.polygonCoords,
                            strokeColor: '#00FF00',
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: '#00FF00',
                            draggable: false,
                            editable: false,
                            fillOpacity: 0.35
                        });				
                    }


                    if(exists(googleMaps.selectedTriangle)){
                        var latlngbounds = new google.maps.LatLngBounds();
                        for (let i = 0; i < googleMaps.polygonCoords.length; i++) {
                            var poly=new google.maps.LatLng(googleMaps.polygonCoords[i].lat, googleMaps.polygonCoords[i].lng)
                            latlngbounds.extend(poly);
                        }
	
                        googleMaps.selectedTriangle.setMap(googleMaps.map);					
                    }
                }				
            }					
        }


        googleMaps.removePloygon = function(){
            if(exists(googleMaps.scope.model)) {					
                if(googleMaps.scope.model.flag==2){										
                    googleMaps.scope.model.flag=0;							
                    googleMaps.scope.value=googleMaps.scope.model.value;				
                    for(var j=0; j<googleMaps.polygonArray.length; j++) {

                        googleMaps.polygonArray[j].setMap(null);
                    }

                    if(exists(googleMaps.selectedShape)){
                        googleMaps.selectedShape.setMap(null);
                    }
                    if(exists(googleMaps.bermudaTriangle)) {
                        googleMaps.bermudaTriangle.setMap(null);
                    }

                    if(exists(googleMaps.selectedTriangle)) {
                        googleMaps.selectedTriangle.setMap(null);
                    }

                    if(exists(googleMaps.newMapDrawn)) {					
                        for(let j=0; j<googleMaps.newMapDrawn.length; j++) {

                            googleMaps.newMapDrawn[j].overlay.setMap(null);
                        }
                    }

                    googleMaps.latlngarray=[];

                    googleMaps.bermudaTriangle=null;	
                    googleMaps.polygonArray = [];
                    googleMaps.polygonCoordsArray=[];	
                    googleMaps.polygonCoords = [];

                    LoadMap();
                    setMapValue();
                }				
            }				   				
        }

        googleMaps.count=0;						
        googleMaps.map = ngMap.getMap().then(function(map) {
            googleMaps.map = map;
            setMapValue();    	
        });		
        googleMaps.selectedShape;

        googleMaps.clearSelection = function() {
            if (googleMaps.selectedShape) {
                googleMaps.selectedShape.setEditable(false);
                googleMaps.selectedShape = null;
            }
        }

        googleMaps.setSelection = function(shape) {
            googleMaps.clearSelection();
            googleMaps.selectedShape = shape;
            shape.setEditable(true);

        }

        googleMaps.deleteSelectedShape = function() {
            if (googleMaps.selectedShape) {
                googleMaps.selectedShape.setMap(null);
            }
        }
        googleMaps.latlngarray=[];		 		  
        googleMaps.answer = "";		
        googleMaps.scope.toggleDrawControl = function() {					  
            googleMaps.scope.map.mapDrawingManager[googleMaps.count].setOptions({
                drawingControl:googleMaps.scope.editable
            });

            googleMaps.scope.map.mapDrawingManager[googleMaps.count].setDrawingMode(null);
        }
        var newShape;
        googleMaps.newMapDrawn=[];
        googleMaps.onMapOverlayCompleted = function(e){	
            googleMaps.newMapDrawn.push(e);	
            var polygonBounds = e.overlay.getPath();
            googleMaps.answer = "POLYGON ((";
            for(var a=0; a<polygonBounds.length; a++) {

                var latlng = {};		  			
                latlng["lat"]=polygonBounds.getAt(a).lat();
                latlng["lng"]=polygonBounds.getAt(a).lng();
                googleMaps.latlngarray.push(latlng);
                googleMaps.answer += polygonBounds.getAt(a).lat() + " " + polygonBounds.getAt(a).lng() + ", ";
                if(a==polygonBounds.length-1) {
                    latlng["lat"]=polygonBounds.getAt(0).lat();
                    latlng["lng"]=polygonBounds.getAt(0).lng();
                    googleMaps.latlngarray.push(latlng);
                    googleMaps.answer += polygonBounds.getAt(0).lat() + " " + polygonBounds.getAt(0).lng() + "))";
                }
            }
            googleMaps.scope.value = googleMaps.answer;
            googleMaps.scope.editable=false;			
            googleMaps.scope.toggleDrawControl();
            googleMaps.count++;					
            newShape = e.overlay;
            newShape.type = e.type;
            google.maps.event.addListener(newShape.getPath(), 'click', function() {
                googleMaps.setSelection(newShape);
            });
            google.maps.event.addListener(newShape.getPath(), 'insert_at', function() {
            });
            google.maps.event.addListener(newShape.getPath(), 'remove_at', function() {
            });
            google.maps.event.addListener(newShape.getPath(), 'set_at', function() {
            });
            googleMaps.setSelection(newShape);
            var paths = newShape.getPath();

            paths.changed=function(){
                var change = this;
                googleMaps.pathChanged(change);
            }           
        }

        googleMaps.pathChanged = function(change) {
//**************************		  	
            function equalCoords(a,b){
                return b.lat() == a.lat() && b.lng() == a.lng(); 
            }
            if(!byUs && !equalCoords(change.getAt(change.length-1),change.getAt(0))){
                change.setAt(0,change.getAt(change.length-1));
                byUs=true;  	
            }
            byUs=false;
//**************************
            googleMaps.answer = "POLYGON((";
            googleMaps.latlngarray=[];
            for(var i=0; i<change.length; i++) {
                var latlng = {};
                latlng["lat"]=change.getAt(i).lat();
                latlng["lng"]=change.getAt(i).lng();
                googleMaps.latlngarray.push(latlng);
                googleMaps.answer += change.getAt(i).lat() + " " + change.getAt(i).lng();
                if(i==change.length-1) {
                    googleMaps.answer += "))";
                }
                else
                    googleMaps.answer += ", "
            }
            googleMaps.scope.value = googleMaps.answer;
        }

        googleMaps.cancel = function() {
            googleMaps.latlngarray = [];
            googleMaps.scope.value = googleMaps.latlngarray;
            googleMaps.deleteSelectedShape();
        }		


        function LoadMap() {			  
            googleMaps.polygonCoords = [];
            googleMaps.polygonCoordsArray = [];
            var fillColor="#000000";
            if(exists(googleMaps.scope.model)) {
                var isEdit= googleMaps.scope.model.isEdit;
                if(isEdit){
                    fillColor="#FF0000";
                }

            }


            if(exists(googleMaps.scope.value) && !angular.isArray(googleMaps.scope.value)) {

                var duplicate = angular.copy(googleMaps.scope.value);
                duplicate = duplicate.replace("POLYGON ((", "");
                let arr = duplicate.split(")");
                let point = arr[0].split(", ");
                for (var i = 0; i<point.length; i++) {
                    var coord = point[i].split(" ");
                    var point_lat = Number(coord[0]);
                    var point_lng = Number(coord[1]);
                    var obj = {lat:point_lat,lng:point_lng};
                    googleMaps.polygonCoords.push(obj);
                }
                googleMaps.bermudaTriangle = new google.maps.Polygon({
                    paths: googleMaps.polygonCoords,
                    strokeColor: fillColor,
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    fillColor: fillColor,
                    draggable: false,
                    editable: false,
                    fillOpacity: 0.35
                });				
            }
            else if(exists(googleMaps.scope.value) && angular.isArray(googleMaps.scope.value)) {

                for(var j=0; j<googleMaps.scope.value.length; j++) {
                    let polygonCoords = [];

                    googleMaps.scope.value[j] = googleMaps.scope.value[j].replace("POLYGON ((", "");
                    var arr = googleMaps.scope.value[j].split(")");
                    var point = arr[0].split(", ");
                    for (let i = 0; i<point.length; i++) {
                        let coord = point[i].split(" ");
                        let point_lat = Number(coord[0]);
                        let point_lng = Number(coord[1]);
                        let obj = {lat:point_lat,lng:point_lng};
                        polygonCoords.push(obj);
                        googleMaps.polygonCoordsArray.push(obj);
                    }
                    var bermudaTriangle = new google.maps.Polygon({
                        paths: polygonCoords,
                        strokeColor: fillColor,
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                        fillColor: fillColor,
                        draggable: false,
                        editable: false,
                        fillOpacity: 0.35
                    });
                    googleMaps.polygonArray.push(bermudaTriangle);
                }
            }
            else
                googleMaps.centre = "24.861876, 67.008308";
        }


        function setMapValue() {			  
            if(exists(googleMaps.bermudaTriangle)){
                var latlngbounds = new google.maps.LatLngBounds();
                for (var i = 0; i < googleMaps.polygonCoords.length; i++) {
                    var poly=new google.maps.LatLng(googleMaps.polygonCoords[i].lat, googleMaps.polygonCoords[i].lng)
                    latlngbounds.extend(poly);
                }

                googleMaps.bermudaTriangle.setMap(googleMaps.map);
                googleMaps.map.setCenter(latlngbounds.getCenter(), googleMaps.map.getZoom(latlngbounds));
                googleMaps.map.fitBounds(latlngbounds);
                googleMaps.centre = latlngbounds.getCenter().lat() + "," + latlngbounds.getCenter().lng();    		
                googleMaps.bermudaTriangle.addListener('click', googleMaps.selectIt);
                var p = googleMaps.bermudaTriangle.getPath();		
                p.addListener('insert_at', googleMaps.edit);
                p.addListener('set_at', googleMaps.edit);
            }
            else if(exists(googleMaps.polygonArray) && googleMaps.polygonArray.length>0) {
                let latlngbounds = new google.maps.LatLngBounds();
                for(var j=0; j<googleMaps.polygonArray.length; j++) {

                    googleMaps.polygonArray[j].setMap(googleMaps.map);
                }
                for (let i = 0; i < googleMaps.polygonCoordsArray.length; i++) {
                    let poly=new google.maps.LatLng(googleMaps.polygonCoordsArray[i].lat, googleMaps.polygonCoordsArray[i].lng)
                    latlngbounds.extend(poly);
                }
                googleMaps.map.fitBounds(latlngbounds);
                googleMaps.map.setCenter(latlngbounds.getCenter(), googleMaps.map.getZoom(latlngbounds));
                googleMaps.centre = latlngbounds.getCenter().lat() + "," + latlngbounds.getCenter().lng();
            }
            google.maps.event.trigger(googleMaps.map, 'resize');
        }

        LoadMap();


        // eslint-disable-next-line no-unused-vars
        googleMaps.selectIt = function(_event) {
            googleMaps.setSelection(googleMaps.bermudaTriangle);
        }

        // eslint-disable-next-line no-unused-vars
        googleMaps.edit = function(_event) {
            googleMaps.pathChanged(googleMaps.bermudaTriangle.getPath());
        }
    }

})();